<div *ngIf="!docked" class="calls-sidebar-overlay" (click)="onClose()"></div>
<aside
    class="calls-sidebar-panel"
    [class.calls-sidebar-panel--wide]="!!activeConversation"
    [class.calls-sidebar-panel--docked]="docked"
>
    <header class="calls-sidebar-header" [class.calls-sidebar-header--thread]="!!activeConversation">
        <button
            *ngIf="activeConversation"
            type="button"
            mat-icon-button
            (click)="onBackFromThread()"
            [attr.aria-label]="'Voltar' | autoTranslate"
        >
            <mat-icon svgIcon="heroicons_outline:arrow-left"></mat-icon>
        </button>
        <mat-icon
            *ngIf="!activeConversation"
            svgIcon="heroicons_outline:chat-bubble-left-right"
            class="header-icon"
        ></mat-icon>
        <div class="header-text">
            <span *ngIf="!activeConversation" class="header-title" autoTranslate>Chat</span>
            <span *ngIf="activeConversation && isGroupLike(activeConversation)" class="header-title" autoTranslate>Grupo</span>
            <span *ngIf="activeConversation && !isGroupLike(activeConversation)" class="header-title">
                {{ activeConversation.display_name }}
            </span>
            <span
                *ngIf="activeConversation?.type === 'SERVICE' && activeConversation?.service_id"
                class="header-sub"
            >
                #{{ activeConversation.service_id }}
                ·
                {{ serviceStartedAt(activeConversation) | timezoneDate: 'dd/MM/yyyy HH:mm' }}
            </span>
            <span *ngIf="activeConversation?.type === 'GROUP'" class="header-sub">
                {{ activeConversation.display_name || activeConversation.name }}
            </span>
        </div>
        <button
            *ngIf="activeConversation && canManageGroup(activeConversation)"
            type="button"
            mat-icon-button
            class="header-edit-btn"
            [matTooltip]="'Editar grupo' | autoTranslate"
            (click)="openEditGroup(activeConversation)"
            [attr.aria-label]="'Editar grupo' | autoTranslate"
        >
            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
        </button>
        <button
            *ngIf="activeConversation && !docked"
            type="button"
            mat-icon-button
            [matTooltip]="'Entrar em vídeo' | autoTranslate"
            (click)="onEnterVideo(activeConversation)"
            [attr.aria-label]="'Entrar em vídeo' | autoTranslate"
        >
            <mat-icon svgIcon="heroicons_outline:video-camera"></mat-icon>
        </button>
        <button type="button" mat-icon-button (click)="onClose()" [attr.aria-label]="'Fechar' | autoTranslate">
            <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
        </button>
    </header>

    <ng-container *ngIf="activeConversation; else listView">
        <div class="thread-host">
            <app-conversation-thread
                [conversation]="activeConversation"
                [currentUserId]="currentUserId"
                [currentUserName]="currentUserName"
                [showHeader]="false"
                [showBack]="false"
                [showVideoButton]="!docked"
                (back)="onBackFromThread()"
                (enterVideo)="onEnterVideo($event)"
            ></app-conversation-thread>
        </div>
    </ng-container>

    <ng-template #listView>
        <ng-container *ngIf="pickingContact; else tabsView">
            <div class="picker-bar">
                <button
                    type="button"
                    mat-icon-button
                    (click)="closeContactPicker()"
                    [attr.aria-label]="'Voltar' | autoTranslate"
                >
                    <mat-icon svgIcon="heroicons_outline:arrow-left"></mat-icon>
                </button>
                <span class="picker-title" autoTranslate>Nova conversa</span>
            </div>
            <div class="picker-search">
                <mat-icon class="picker-search-icon" svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
                <input
                    type="search"
                    class="picker-search-input"
                    [(ngModel)]="contactSearch"
                    [placeholder]="'Pesquisar contatos' | autoTranslate"
                    [attr.aria-label]="'Pesquisar contatos' | autoTranslate"
                />
            </div>
            <div class="calls-sidebar-content">
                <ng-container *ngIf="filteredContactGroups.length > 0; else noContacts">
                    <div *ngFor="let company of filteredContactGroups" class="contact-company">
                        <h4 class="company-label" *ngIf="company.companyName">{{ company.companyName }}</h4>
                        <h4 class="company-label" *ngIf="!company.companyName" autoTranslate>Administração</h4>
                        <div *ngFor="let role of company.roles" class="contact-role">
                            <h5 class="role-label">{{ role.roleLabel | autoTranslate }} ({{ role.contacts.length }})</h5>
                            <ul class="user-list">
                                <li *ngFor="let u of role.contacts" class="user-item" (click)="onContactChat(u)">
                                    <span
                                        class="user-avatar"
                                        [class.user-avatar--online]="u.status === 'AVAILABLE'"
                                        [class.user-avatar--busy]="u.status === 'BUSY'"
                                        [class.user-avatar--offline]="!u.is_online"
                                        [matTooltip]="u.name"
                                    >{{ getInitials(u.name) }}</span>
                                    <div class="user-info">
                                        <span class="user-name">{{ u.name }}</span>
                                        <span class="user-badge">{{ contactBadge(u) | autoTranslate }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ng-container>
                <ng-template #noContacts>
                    <p class="empty-hint" autoTranslate>Nenhum contato encontrado.</p>
                </ng-template>
            </div>
        </ng-container>

        <ng-template #tabsView>
            <div class="sidebar-tabs" role="tablist">
                <button
                    type="button"
                    role="tab"
                    class="sidebar-tab"
                    [class.sidebar-tab--active]="listTab === 'groups'"
                    [attr.aria-selected]="listTab === 'groups'"
                    (click)="listTab = 'groups'"
                >
                    <span autoTranslate>Grupos</span>
                </button>
                <button
                    type="button"
                    role="tab"
                    class="sidebar-tab"
                    [class.sidebar-tab--active]="listTab === 'chats'"
                    [attr.aria-selected]="listTab === 'chats'"
                    (click)="listTab = 'chats'"
                >
                    <span autoTranslate>Conversas</span>
                </button>
            </div>

            <ng-container *ngIf="listTab === 'groups'">
                <div class="sidebar-tabs sidebar-tabs--sub" role="tablist">
                    <button
                        type="button"
                        role="tab"
                        class="sidebar-tab"
                        [class.sidebar-tab--active]="groupsSubTab === 'services'"
                        [attr.aria-selected]="groupsSubTab === 'services'"
                        (click)="groupsSubTab = 'services'"
                    >
                        <span autoTranslate>Atendimentos</span>
                        <span>({{ serviceGroupConversations.length }})</span>
                    </button>
                    <button
                        type="button"
                        role="tab"
                        class="sidebar-tab"
                        [class.sidebar-tab--active]="groupsSubTab === 'general'"
                        [attr.aria-selected]="groupsSubTab === 'general'"
                        (click)="groupsSubTab = 'general'"
                    >
                        <span autoTranslate>Gerais</span>
                        <span>({{ generalGroupConversations.length + extraVideoRooms.length }})</span>
                    </button>
                </div>

                <div class="calls-sidebar-actions" *ngIf="groupsSubTab === 'general'">
                    <button
                        *hasPermission="'CONVERSATION_CREATE'"
                        type="button"
                        mat-stroked-button
                        color="primary"
                        class="action-btn"
                        (click)="openCreateGroup()"
                    >
                        <mat-icon svgIcon="heroicons_outline:user-group"></mat-icon>
                        <span autoTranslate>Novo grupo</span>
                    </button>
                </div>

                <div class="calls-sidebar-content">
                    <section class="calls-sidebar-section" *ngIf="groupsSubTab === 'services'">
                        <ul class="conv-list">
                            <li
                                *ngFor="let c of serviceGroupConversations"
                                class="conv-item"
                                (click)="onConversationClick(c)"
                            >
                                <mat-icon
                                    class="conv-lead-icon"
                                    svgIcon="heroicons_outline:clipboard-document-list"
                                ></mat-icon>
                                <div class="conv-info">
                                    <div class="conv-top conv-top--start">
                                        <span class="conv-name">#{{ c.service_id }}</span>
                                        <span class="conv-time" *ngIf="serviceStartedAt(c)">
                                            {{ serviceStartedAt(c) | timezoneDate: 'dd/MM/yyyy HH:mm' }}
                                        </span>
                                    </div>
                                    <div class="conv-meta">
                                        <span class="conv-preview">
                                            {{ messageCount(c) }}
                                            {{ (messageCount(c) === 1 ? 'mensagem' : 'mensagens') | autoTranslate }}
                                            <ng-container *ngIf="lastActivityAt(c)">
                                                - {{ 'última' | autoTranslate }} {{ relativeAgo(lastActivityAt(c)) }}
                                            </ng-container>
                                        </span>
                                        <span *ngIf="c.unread_count > 0" class="conv-unread">{{ c.unread_count }}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <p *ngIf="serviceGroupConversations.length === 0" class="empty-hint" autoTranslate>
                            Nenhum atendimento aberto.
                        </p>
                    </section>

                    <section class="calls-sidebar-section" *ngIf="groupsSubTab === 'general'">
                        <ul class="conv-list">
                            <li
                                *ngFor="let c of generalGroupConversations"
                                class="conv-item"
                                (click)="onConversationClick(c)"
                            >
                                <mat-icon
                                    class="conv-lead-icon"
                                    svgIcon="heroicons_outline:user-group"
                                ></mat-icon>
                                <div class="conv-info">
                                    <div class="conv-top conv-top--start">
                                        <span class="conv-name">{{ c.display_name || c.name }}</span>
                                        <span class="conv-time" *ngIf="c.createdAt">
                                            {{ c.createdAt | timezoneDate: 'dd/MM/yyyy HH:mm' }}
                                        </span>
                                    </div>
                                    <div class="conv-meta">
                                        <span class="conv-preview">
                                            {{ messageCount(c) }}
                                            {{ (messageCount(c) === 1 ? 'mensagem' : 'mensagens') | autoTranslate }}
                                            <ng-container *ngIf="lastActivityAt(c)">
                                                - {{ 'última' | autoTranslate }} {{ relativeAgo(lastActivityAt(c)) }}
                                            </ng-container>
                                        </span>
                                        <span *ngIf="c.unread_count > 0" class="conv-unread">{{ c.unread_count }}</span>
                                    </div>
                                </div>
                            </li>
                            <li
                                *ngFor="let room of extraVideoRooms"
                                class="conv-item"
                                (click)="onRoomClick(room)"
                            >
                                <mat-icon
                                    class="conv-lead-icon"
                                    svgIcon="heroicons_outline:video-camera"
                                ></mat-icon>
                                <div class="conv-info">
                                    <div class="conv-top conv-top--start">
                                        <span class="conv-name">{{ room.name }}</span>
                                    </div>
                                    <span class="conv-preview">{{ room.onlineCount }} {{ 'online' | autoTranslate }}</span>
                                </div>
                            </li>
                        </ul>
                        <p *ngIf="generalGroupConversations.length === 0 && extraVideoRooms.length === 0" class="empty-hint" autoTranslate>
                            Nenhum grupo criado.
                        </p>
                    </section>
                </div>
            </ng-container>

            <ng-container *ngIf="listTab === 'chats'">
                <div class="calls-sidebar-actions">
                    <button
                        *hasPermission="'CONVERSATION_CREATE'"
                        type="button"
                        mat-stroked-button
                        color="primary"
                        class="action-btn"
                        (click)="openContactPicker()"
                    >
                        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                        <span autoTranslate>Nova</span>
                    </button>
                </div>

                <div class="calls-sidebar-content">
                    <section class="calls-sidebar-section">
                        <ul class="conv-list">
                            <li
                                *ngFor="let c of directConversations"
                                class="conv-item"
                                (click)="onConversationClick(c)"
                            >
                                <span
                                    class="conv-avatar"
                                    [class.user-avatar--online]="peerStatus(c) === 'AVAILABLE'"
                                    [class.user-avatar--busy]="peerStatus(c) === 'BUSY'"
                                >{{ getInitials(c.display_name) }}</span>
                                <div class="conv-info">
                                    <div class="conv-top">
                                        <span class="conv-name">{{ c.display_name }}</span>
                                        <span *ngIf="c.last_message_at" class="conv-time">
                                            {{ c.last_message_at | timezoneDate: 'HH:mm' }}
                                        </span>
                                        <span *ngIf="c.unread_count > 0" class="conv-unread">{{ c.unread_count }}</span>
                                    </div>
                                    <span *ngIf="peerBadge(c) as badge" class="user-badge">{{ badge | autoTranslate }}</span>
                                    <span class="conv-preview">{{ lastPreview(c) }}</span>
                                </div>
                            </li>
                        </ul>
                        <p *ngIf="directConversations.length === 0" class="empty-hint" autoTranslate>
                            Nenhuma conversa ainda. Toque em Nova para iniciar.
                        </p>
                    </section>
                </div>
            </ng-container>
        </ng-template>
    </ng-template>
</aside>
